import { useEffect, useState } from "react";
import isMobile from 'helpers/isMobile'

const MOBILE_WIDTH_BREAKPOINT = 1230

const useIsMobile = () => {
    const [mobile, setMobile] = useState(isMobile() || window.innerWidth < MOBILE_WIDTH_BREAKPOINT);
    useEffect(() => {
        const cb = () => {
            setMobile(isMobile() || window.innerWidth < MOBILE_WIDTH_BREAKPOINT);
        };
        window.addEventListener("resize", cb);
        return () => window.removeEventListener("resize", cb);
    }
    , []);
    
    return mobile;
};

export default useIsMobile;